<template>
  <div class="el-select-dict" ref="container">
    <div class="title">基础用法</div>
    <el-select-dict @dictChange="handdleChange" clearable v-model="value1" dictType="PERSON_TYPE">
      <template #prefix>
        哈哈哈
      </template>
    </el-select-dict>
    <el-select @change="handdleChange" clearable v-model="value1">
      <template #prefix>
        哈哈哈
      </template>
    </el-select>
    
    <div class="title">过滤数据</div>
    <el-select-dict @dictChange="handdleChange"  clearable v-model="value2" :dictType="{type: 'PERSON_TYPE', filters: '001,002'}">
      <template slot="empty">
        哈哈哈
      </template>
    </el-select-dict>
    <el-select-dict @dictChange="handdleChange"  clearable v-model="value3" :filterDataFun="filterDataFun" dictType="PERSON_TYPE"></el-select-dict>
    
    <div class="title">禁用数据</div>
    <el-select-dict @dictChange="handdleChange" dictType="PERSON_TYPE" clearable v-model="value4" :disableObj="{disableValue: '001,002'}"></el-select-dict>
    <el-select-dict @dictChange="handdleChange" dictType="PERSON_TYPE" :disabledDataFun="disabledDataFun" clearable v-model="value5"></el-select-dict>
   
    <div class="title">配置keyValue及赋值</div>
    <el-select-dict @dictChange="handdleChange" clearable v-model="value6" dictType="PERSON_TYPE"></el-select-dict>
    <el-select-dict @dictChange="handdleChange" :keyValue="true" clearable v-model="value7" dictType="PERSON_TYPE"></el-select-dict>
    <el-select-dict @dictChange="handdleChange" multiple clearable v-model="value8" dictType="PERSON_TYPE"></el-select-dict>
    <el-select-dict @dictChange="handdleChange" multiple :keyValue="true" clearable v-model="value9" dictType="PERSON_TYPE"></el-select-dict>
  </div>
</template>

<script>
export default {
  name: "el-select-dict-index",
  data() {
    return {
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "001",
      value7: {
        value: "001",
        label: "企业法人"
      },
      value8: ["001", "002"],
      value9: [
        {
          value: "001",
          label: "企业法人"
        },
        {
          value: "002",
          label: "社团法人" 
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const container = this.$refs.container
        const data = {"demoContainerHeight": container.scrollHeight + 20}
        window.parent.postMessage(data, "*")
      }, 1000)
    })
  },
  methods: {
    handdleChange(val) {
      console.log(val)
    },
    //过滤数据
    filterDataFun(list) {
      return list.filter(item => {
        return item.value === "001" || item.value === "002"
      })
    },
    //禁用数据
    disabledDataFun(list) {
      return list.map(item => {
        return {
          ...item,
          disabled: !!(item.value === "001" || item.value === "002")
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-select-dict{
  .el-select + .el-select{
    margin-left: 10px;
  }
}
</style>